export default __webpack_public_path__ + "static/media/lehigh-3.24fc948d.png";